import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-style-one-page',
  templateUrl: './work-style-one-page.component.html',
  styleUrls: ['./work-style-one-page.component.scss']
})
export class WorkStyleOnePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
